import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { ElTable, ElTableColumn, ElButton, ElDialog, ElDescriptions, ElDescriptionsItem, ElCheckbox, ElImage, ElRadioGroup, ElRadioButton } from 'element-plus';
import 'element-plus/dist/index.css'; // 引入样式
const app = createApp(App); // 传入 App 组件
// 全局注册 Table 组件
app.component('ElTable', ElTable);
app.component('ElTableColumn', ElTableColumn);
app.component('ElButton', ElButton)
app.component('ElDialog', ElDialog)
app.component('ElDescriptions', ElDescriptions)
app.component('ElDescriptionsItem', ElDescriptionsItem)
app.component('ElCheckbox', ElCheckbox)
app.component('ElImage', ElImage)
app.component('ElRadioGroup', ElRadioGroup)
app.component('ElRadioButton', ElRadioButton)

app.use(router).mount('#app')
